import React, { useEffect, useState, useRef } from "react";
import ReactStars from "react-rating-stars-component";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import DataGrid from "../common/DataGrid";
import Header from "../common/Header";
import Loader from "../common/Loader";
import DeleteModal from "../common/Modal/DeleteGridModal";
import Modal from "../common/Modal/modal";
import Sidebar from "../common/Sidebar";
import { editPost, resetJobOpportunityInfo, setJobId } from "../JobOpportunity/action";
import {
  updateJobId
} from '../JobOpportunity/Summary/action';
import ShiftCount from "../ShiftCount";
import {
  clearData, deleteJob, firstPage, gotoPage, lastPage, loadMasterDatas, loadShiftsCoverageListings, nextPage, previousPage,
  setPageSize, UnclaimedbyEmployerApi, updateSort, multishiftFlag,
  getMultiShiftDetail,
  DeleteMultiShiftJob,
  editSaveTimeOccurrence,
  resetMatchingCandidateInfo,
  multishiftUnClaimByEmpFlag,
  UnclaimMultiShiftJob,
  getUnClaimEmployerReasons,
  getDeleteEmployerReasons,
  getCallHistory,
  getEmailDetails,
  getSMSDetails,
  sendAllEmailbtn,
  sendAllSmsbtn,
  sendEmail,
  sendSMS,
  getJobDepartmentList,
  fetchDollarDetails,
} from "./action";
import GPSInfo from "./GPSInfo";
import './index.css';
import { shiftsCoverageSelector } from './selector';
import ShiftsCoverageFilter from "./shiftsCoverageFilter";
import { createHeaders, createPageData } from "./shiftsOpenAllCoverageUtilities";

import { jobListingSelector } from './selector';
import Unclaimedmodalpopup from "./Unclaimedmodalpopup";
import { BiMessageEdit } from "react-icons/bi";
import { resetModifyOccurrence, updateRequest } from "../ViewJob/action";
import ModalGoTo from "./ModalGoTo";
import ViewJob from "../ViewJob";
import { viewJobSelector } from "../ViewJob/selector";
import Spinner from "../common/Spinner/spinner";
import { toast } from "react-toastify";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { refreshMultishiftInfo, cleartTableData } from "./slice";
import EmailModal from "../common/Modal/EmailModal";
import SMSModal from "../common/Modal/SMSModal";
import CallModal from "../common/Modal/CallModal";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import moment from "moment";
import PayRateTable from "../common/Table/PayRateTable";
import { payRateTypeObj, shiftTypeObj, tiltedColorCode } from "../../helpers/data";
import { getSortOrder } from "../../helpers/service";
import { setIsErrorPaymentRate } from "../ViewJob/slice";
import Mentor from "../assets/svg/Mentor";


// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
  const navigate = useNavigate();
  const [openGps, setOpenGps] = useState({
    show: false,
    jobData: undefined
  });
  const [openMessaging, setOpenMessaging] = useState({
    open: false,
    jobId: undefined
  });
  const [deletedata, setdeletedata] = useState({
    show: false,
    jobId: undefined
  });
  const [Unclaimdata, setUnclaimData] = useState(false);
  const headers = createHeaders();
  const dispatch = useDispatch();
  const config = useConfiguration();
  const storage = useSessionStorage();
  const login = storage.getItem('login');
  const { data, pageSize, page, gridloader, matchingCandidateinfo, multiShiftclaimDetailFlag, multiShiftclaimedDetail, multiShiftUnClaimFlag, loadingFlag, unClaimEmployerReasons, deleteEmployerReasons, updatedShiftTime } = useSelector(shiftsCoverageSelector);
  const empId = login.employerUniqueId;
  const url = config.baseUrl;
  const AppuseridValue = login.appUserId;
  const [show, setShow] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [UnclaimId, setUnclaimId] = useState('');

  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showJobMessageModal, setShowJobMessageModal] = useState(false);
  const [mulJobUniqueId, setmulJobUniqueId] = useState('')

  const [showViewJob, setShowViewJob] = useState(false);
  const { requestData, jobInfo, shift } = useSelector(viewJobSelector);
  const jobsShiftsDepartmentsList = useSelector(store => store.viewJobDetails.jobsShiftsDepartmentsList);
  const payRateTotalShiftAmount = useSelector(store => store.viewJobDetails.payRateTotalShiftAmount);
  const payRateType = useSelector(store => store.viewJobDetails.payRateType);
  const [callUnclainForChild, setcallUnclainForChild] = useState(false);
  const [unclaimForChild, setUnclaimForChild] = useState({})
  // Email state 
  const [emailModalInd, setEmailModalInd] = useState(false);
  const [emailModalData, setEmailModalData] = useState([]);
  const [emailModalGetData, setEmailModalGetData] = useState({ subject: "" });
  const [emailModalList, setEmailModalList] = useState([]);

  // SMS state
  const [smsModalList, setSmsModalList] = useState([]);
  const [smsModalInd, setSmsModalInd] = useState(false);
  const [smsModalData, setSmsModalData] = useState({});
  const [smsModalGetData, setSmsModalGetData] = useState({ sms: "" });
  const [smsShiftCoveragePageFlag, setSmsShiftCoveragePageFlag] = useState(false);
  const [candidateName, setCandidateName] = useState('');

  // Call state
  const [callModalInd, setCallModalInd] = useState(false);
  const [callModalData, setCallModalData] = useState([]);
  const [callModalGetData, setCallModalGetData] = useState({ subject: "" });
  const [callModalList, setCallModalList] = useState([]);
  const [callParams, setCallParams] = useState("");

  // Email,SMS,Call Invalid State
  const [showInvalidStatus, setShowInvalidStatus] = useState({
    cellPhoneNumber: false,
    SMS: false,
    email: false
  })

  // Confirmation Modal Box Dropdown Form initial data
  const [ModalFormData, setModalFormData] = useState({
    reason: "",
    comments: "",
  });
  // Confirmation Modal Box Dropdown Form Error initial data
  const [ErrorsModalFormData, setErrorsModalFormData] = useState({
    reasonError: "",
    commentsError: "",
  });
  // Confirmation Modal Box Dropdown Form HandleChange Function
  const ConfirmationModalBoxHandleChange = (e) => {
    setModalFormData({
      ...ModalFormData,
      [e.target.name]: e.target.value,
    });
  };

  // Delete Confirmation Modal Box Dropdown Form initial data
  const [DeleteModalFormData, setDeleteModalFormData] = useState({
    reason: "",
    comments: "",
  });

  // Delete Confirmation Modal Box Dropdown Form Error initial data
  const [DeleteErrorsModalFormData, setDeleteErrorsModalFormData] = useState({
    reasonError: "",
    commentsError: "",
  });

  // Delete Confirmation Modal Box Dropdown Form HandleChange Function
  const DeleteConfirmationModalBoxHandleChange = (e) => {
    setDeleteModalFormData({
      ...DeleteModalFormData,
      [e.target.name]: e.target.value,
    });
  };

  const childRef = useRef();

  useEffect(() => {
    if (config.baseUrl) {
      dispatch(loadMasterDatas(config.baseUrl, empId)).then(() => {
        dispatch(loadShiftsCoverageListings({ url, empId }));
      })
      // UnClaim Reasons API Method
      dispatch(getUnClaimEmployerReasons(`${config.baseUrl}`));
      // Delete Reasons API Method
      dispatch(getDeleteEmployerReasons(`${config.baseUrl}`));
    }
  }, [config]);

  useEffect(() => {
    return () => {
      dispatch(cleartTableData());
      dispatch(clearData());
    }
  }, [dispatch])
  if (matchingCandidateinfo?.jobShiftUniqueId && matchingCandidateinfo?.navigateMatchingCandidate && matchingCandidateinfo?.editJobUniqueId) {
    navigate("/matchingcandidate",
      {
        state: {
          matchingJobid: matchingCandidateinfo?.jobShiftUniqueId,
          acceptableTravelDistance: matchingCandidateinfo?.acceptableTravelDistance,
          jobsClaimId: matchingCandidateinfo?.jobsClaimId,
          jobUniqueId: matchingCandidateinfo?.editJobUniqueId,
          NoOfShiftsneeded: false,
          previousPath: '/shiftscoverage',
          hideEditJobShiftType:requestData?.shiftType
        }
      })
    dispatch(resetMatchingCandidateInfo())
  }


  const gotoFirstPage = () => {
    dispatch(firstPage()).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    });
  }
  const gotoNextPage = () => {
    dispatch(nextPage()).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    });
  }
  const gotoPreviousPage = () => {
    dispatch(previousPage()).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    });
  }
  const gotoLastPage = () => {
    dispatch(lastPage()).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    });
  }
  const gotoSelectedPage = (page) => {
    dispatch(gotoPage(page)).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    });
  }
  const updatePageSize = (size) => {
    dispatch(setPageSize(size)).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    });
  }
  const refresh = () => {
    childRef.current.refreshDashboardData()
    if (config.baseUrl) {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    }
  }
  const viewJobinSamePage = (jobId, shiftDate, claimId, shiftStartTime, shiftEndTime, jobsShiftUniqueId, save, shiftType) => {
    dispatch(updateRequest({ jobId, shiftDate, claimId, shiftStartTime, shiftEndTime, jobsShiftUniqueId, save, shiftType, viewJobTitle: "Shift Awaiting Approval" })).then(() => {
      setShowViewJob(!showViewJob)
    });
  };
  const saveViewJob = () => {
    if( (+payRateType === payRateTypeObj?.manualCal) && !payRateTotalShiftAmount){
      dispatch(setIsErrorPaymentRate(true))
      return
    }
    const params = {
      "jobShiftUniqueId": requestData?.jobsShiftUniqueId,
      "shiftDateTime": requestData?.shiftDate,
      "singleShiftEndDate":shift?.endDate,
      "shiftStartTime": shift?.startTime?.name,
      "shiftEndTime": shift?.endTime?.name,
      "incentive": jobInfo?.incentive?.toString(),
      "jobsClaimId": requestData?.claimId,
      candidateDepartmentId: jobsShiftsDepartmentsList?.length ? jobsShiftsDepartmentsList?.at(0)?.id : [],
      DepartmentName: jobsShiftsDepartmentsList?.length ? jobsShiftsDepartmentsList?.at(0)?.name : [],
      payRateType: payRateType ?? null,
      manualTotalShiftAmount: (+payRateType === payRateTypeObj?.manualCal) ? payRateTotalShiftAmount : null,
      manualAmountPerShift: null
    }
    dispatch(editSaveTimeOccurrence(`${config.baseUrl}/Employers/savejobsunclaimedoccurance`, params,requestData?.shiftType)).then((response) => {
      if(response?.jobShiftUniqueId && response?.jobUniqueId){
        navigate("/daily-encounter-info", {
          state: {
            encounterData: response,
            calendar:true,
            pageName: "shiftscoverage",
            viewJobTitle: "Shift Awaiting Approval"
          },
        });
      }
      setShowViewJob(!showViewJob);
    }).then(() => dispatch(resetModifyOccurrence()))
  }
  const navigateMultiShift = (jobId, isClaimed, acceptableTravelDistance, candidateUniqueId, jobsShiftUniqueId) => {
    navigate("/multiShiftJobInfo", {
      state: {
        multiShiftId: jobId,
        acceptableTravelDistance: acceptableTravelDistance,
        candidateUniqueId: candidateUniqueId,
        jobsShiftUniqueId,
        pageName: "shiftscoverage",
        viewJobTitle: "Shift Awaiting Approval"
      },
    });
  };
  // const navigateDailyEncounterInfo = (jobShiftId, isClaimed, acceptableTravelDistance, candidateUniqueId) => {
  //   navigate("/daily-encounter-info", {
  //     state: {
  //       encounterId: jobShiftId,
  //       acceptableTravelDistance: acceptableTravelDistance,
  //       candidateUniqueId: candidateUniqueId
  //     },
  //   });
  // };

  const navigateDailyEncounterInfo = (data) => {
    navigate("/daily-encounter-info", {
      state: {
        encounterData: data,
        pageName: "shiftscoverage",
        viewJobTitle: "Shift Awaiting Approval"
      },
    });
  };

  const createStarforFavorite = (flag) => {
    const star = {
      size: 20,
      count: 1,
      value: flag ? 1 : 0,
      edit: false,
      color: flag ? 'green' : 'Grey',
      activeColor: flag ? 'green' : 'Grey',
      a11y: true,
      isHalf: true,
      emptyIcon: <i className="fa fa-star-o" />,
      halfIcon: <i className="fa fa-star-half-o" />,
      filledIcon: <i className="fa fa-star" />
    }
    return <ReactStars {...star} />
  }

  // closeInvalidEmailSMSPhoneNumber
  const closeInvalidStatus = () => {
    if (showInvalidStatus?.email) {
      setShowInvalidStatus(prev => ({ ...prev, ["email"]: false }))
    } else if (showInvalidStatus?.cellPhoneNumber) {
      setShowInvalidStatus(prev => ({ ...prev, ["cellPhoneNumber"]: false }))
    } else if (showInvalidStatus?.SMS) {
      setShowInvalidStatus(prev => ({ ...prev, ["SMS"]: false }))
    }
  }

  // Show Email Modal popup
  const showEmailModal = async (data) => {
    getEmailModalData("subject", "");
    if (emailModalInd) {
      setEmailModalList([]);
    } else {
      const emailDetailsResult = await dispatch(
        getEmailDetails({
          url: `${config.baseUrl}/Messaging/get-email-messages/${data.candidateUniqueId}`,
        }),
      );
      if (Array.isArray(emailDetailsResult) && emailDetailsResult?.length) setEmailModalList(emailDetailsResult);
    }
    setEmailModalData((preVal) => [data]);
    setEmailModalInd((preVal) => !preVal);
  };

  // Text box value sepetare 
  const valueJoinWithComma = (inputValue, key) => {
    let returnValue = "";
    if (!inputValue) return returnValue;
    if (!key) {
      returnValue = inputValue.join(",");
    } else {
      returnValue = inputValue.map((e) => e[key]).join(",");
    }
    return returnValue;
  };

  // Save Method Email modal popup
  const saveEmailModal = async (sessionUniqueId) => {
    const description = window.emailSummaryNoteValue();
    if (emailModalGetData.subject && description) {
      const requestBody = {
        candidateUniqueId: valueJoinWithComma(
          emailModalData,
          "candidateUniqueId",
        ),
        emailSubject: emailModalGetData.subject,
        messageBody: description,
        sessionId: sessionUniqueId,
        employerUniqueId: login?.employerUniqueId,
      };
      await dispatch(
        sendEmail({
          url: `${config.baseUrl}/Messaging/send-email-to-candidate`,
          params: requestBody,
        }),
      );
      showEmailModal();
    } else {
      toast.error('Subject field is required')
    }
  };

  // get a Email details Method modal poup
  const getEmailModalData = (index, value) => {
    setEmailModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Show SMS Modal box
  const showSmsModal = async (data) => {
    const fistname = data?.candidateFirstName
    ? data?.candidateFirstName
    : "";
  const lastName = data?.candidateLastName
    ? data?.candidateLastName
    : "";
  const displayname = fistname + " " + lastName;
  setCandidateName(displayname);
    if (smsModalInd) {
      setSmsModalList([]);
      setSmsShiftCoveragePageFlag(false);
    } else {
      if (!!login?.verifiedPhoneNumber) {
        const params = {
          candidateUniqueId: data?.candidateUniqueId,
          employerMobileNumber: login.verifiedPhoneNumber,
          candidateMobileNumber: `${login.countryPhoneCode}${(data.cellPhoneNumber).replace(/-/g, '')}`
        }
        const smsDetailsResult = await dispatch(
          getSMSDetails({

            url: `${config.baseUrl}/Messaging/get-sms-messages`, params
          }),
        );
        setSmsModalList(smsDetailsResult);
        setSmsShiftCoveragePageFlag(true);
      } else {
        toast.error("SMS faciality not mapped to this employer.")
        return
      }
    }
    getSmsModalData("sms", "");
    setSmsModalData(data);
    setSmsModalInd((preVal) => !preVal);
  };

  // Save Single SMS Modal box
  const saveSmsModal = async () => {
    const requestBody = {
      candidateUniqueId: smsModalData.candidateUniqueId,
      messageBody: smsModalGetData.sms,
    };
    await dispatch(
      sendSMS({
        url: `${config.baseUrl}/Messaging/send-sms-to-candidate`,
        params: requestBody,
      }),
    );
    setSmsShiftCoveragePageFlag(false);
    showSmsModal();
  };

  // get Modal data
  const getSmsModalData = (index, value) => {
    setSmsModalGetData((preVal) => {
      return {
        ...preVal,
        [index]: value,
      };
    });
  };

  // Send All for Email
  const sendAllEmail = () => {
    dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Messaging/sendallemails`)).then((res) => {
      if (res.status === 200) {
        toast.success('Email sent successfully!')
      } else {
        toast.error('Email Not sent!')
      }
    })
    showEmailModal();
  };

  // Email Read
  const sendReadEmail = () => {
    if (config.baseUrl) {
      dispatch(sendAllEmailbtn(`${config.baseMailUrl}/Email/email-read-by-Graph`))
        .then((res) => {
          if (res.status === 200) {
            toast.success('Employer Email details updated successfully')
          } else {
            toast.error('Employer Email details are not updated')
          }
        })
    }
    showEmailModal();
  };

  // Send All for SMS
  const sendAllSms = () => {
    dispatch(
      sendAllSmsbtn('https://development.overturexl.com/DevMessagingApi/api/Messaging/sendSMS')
    );
    showSmsModal();
  };

  // Call Modal 
  const showCallModal = (data) => {
    if (callModalInd) {
      setCallModalList([]);
    } else {
      const params = {
        phoneNumber: `${login.countryPhoneCode}${(data.cellPhoneNumber).replace(/-/g, '')}`
      }
      dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
        if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
      })
      setCallParams({
        phoneNumber: data.cellPhoneNumber,
        candidateUniqueId: data.candidateUniqueId,
        jobsClaimId: data.jobsClaimId,
        jobsShiftUniqueId: data?.jobShiftUniqueId
      });
    }
    setCallModalData((preVal) => [data]);
    setCallModalInd((preVal) => !preVal);
  };

  // Once hangUP the Call that time Call History API Updated
  const getCallHistoryList = (phone) => {
    const params = {
      phoneNumber: `${(phone).replace(/-/g, '')}`
    }
    dispatch(getCallHistory(config.baseUrl, params)).then((callDetailsResult) => {
      if (Array.isArray(callDetailsResult) && callDetailsResult?.length) setCallModalList(callDetailsResult);
    })
  }

  const departmentRef = useRef(null);
  const [showDepartmentList, setShowDepartmentList] = useState({ status: false, jobShiftId: null, result: [] })
  const [popupPosition, setPopupPosition] = useState({ top: 0, left: 0 });

  const handleOutsideClick = () => {
    console.log('Clicked outside!');
    setShowDepartmentList({ status: false, jobShiftId: null, result: [] })
  };
  // useOutsideClick(departmentRef, handleOutsideClick);

  const clickJobDepartmentHandler = (e, data) => {
    const rect = e.target.getBoundingClientRect();
    // setPopupPosition({ top: rect.bottom - 10, left: rect.left + 40 });
    const { jobShiftId } = data;
    // if(jobShiftId === showDepartmentList?.jobShiftId){
    //   setShowDepartmentList(prev => ({...prev,status:!showDepartmentList?.status,jobShiftId}))
    //   return
    // }
    dispatch(getJobDepartmentList({ url: `${config.baseUrl}/JobsShiftDepartments/get-jobsshift-department?jobsShiftId=${jobShiftId}` })).then(response => {
      // console.log({response});
      if (+response?.result === 1) {
        setShowDepartmentList(prev => ({ ...prev, status: true, jobShiftId, result: response?.departmentList }))
      }
    })

  }
  const [dollarOpen, setDollarOpen] = useState({ status: false, jobShiftUniqueId: null, result: [], shiftType: null })
  const getDollarDetails = (data) => {
    const { candidateId, jobShiftUniqueId, shiftType } = data;
    const params = {
      candidateId,
      jobShiftUniqueId,
      candidateDepartmentId: [0]
    }
    if (data?.payRateSetupFlag && (dollarOpen?.jobShiftUniqueId !== jobShiftUniqueId)) {
      dispatch(fetchDollarDetails({ url: `${config.baseUrl}/Employers/candidates-payrate-setup`, params })).then(response => {
        setDollarOpen(prev => ({ ...prev, status: true, jobShiftUniqueId, result: response, shiftType }))
      })
    }
  }
  const generateRowData = (data, headers) => {
    const rowData = {};
    headers.forEach(header => {
      if (header.type === 'text') {
        if (typeof header.field === 'array') {
          rowData[header.name] = header.field.map(fld => data[fld]).join(" ");
        } else {
          if (header.field === "serialNo") {
            rowData[header.name] = (
              <span style={{ color: data?.isPosted ? "" : "red" }}>#
                <span style={{ fontWeight: "bold" }}>{data['id']}</span>
              </span>
            );
          } else {
            rowData[header.name] = (
              <span style={{ color: data?.isPosted ? "" : "red" }}>
                {data[header.field]}
              </span>
            );
          }
        }
        const fistname = data['candidateFirstName'] ? data['candidateFirstName'] : '';
        const lastName = data['candidateLastName'] ? data['candidateLastName'] : '';
        const displayname = fistname + ' ' + lastName
        if (header.field === 'name') {
          rowData[header.name] = <span style={{ color: data?.isPosted ? '' : 'red' }}>{displayname}</span>;
        }
        // if (header.field === "departmentName") {
        //   rowData[header.name] = <span>{data?.departmentName ?? ""}</span>
        // }
        if (header.field === "email") {
          rowData[header.name] =
            displayname.length > 1 ? (
              <div style={{ display: 'flex', marginLeft: "5px", alignItems: "center", height: "100%" }}>
                <span onClick={() => showEmailModal(data)} className='connection'>
                  <i
                    class="ti-email"
                    style={{
                      color: "#fff",
                      fontWeight: '500',
                      fontSize: '16px'
                    }}
                  ></i>
                </span>
              </div>
            ) : (
              ""
            );
        }
        if (header.field === "cellPhoneNumber") {
          rowData[header.name] =
            displayname.length > 1 ? (
              <div style={{ display: 'flex', marginLeft: "5px", alignItems: "center", height: "100%" }}>
                <span onClick={() => showCallModal(data)} className='connection'>
                  <i
                    class="fe fe-phone-call"
                    style={{
                      color: "#fff",
                      fontWeight: '500',
                      fontSize: '16px'
                    }}
                  ></i>
                </span>
              </div>
            ) : (
              ""
            );
        }
        if (header.name === "SMS") {
          rowData[header.name] =
            displayname.length > 1 ? (
              <div style={{ display: 'flex', marginLeft: "5px", alignItems: "center", height: "100%" }}>
                <span onClick={() => showSmsModal(data)} className='connection'>
                  <i
                    class="fa fa-commenting-o"
                    style={{
                      color: "#fff",
                      fontWeight: '500',
                      fontSize: '16px'
                    }}
                  ></i>
                </span>
              </div>
            ) : (
              ""
            );
        }
        // if (header.field === "email") {
        //   const isEmailExist = data["email"];
        //   rowData[header.name] =
        //   <div style={{display: "inline-block"}}>
        //     <span 
        //     onClick={() => {
        //       if(isEmailExist){
        //         showEmailModal(data)
        //       } else {
        //         setShowInvalidStatus(prev => ({...prev,["email"]:true}))
        //       }
        //     }} className='connection'>
        //     <i
        //       class="ti-email"
        //       style={{
        //         color: "#fff",
        //         fontWeight: '500',
        //         fontSize: '16px'
        //       }}
        //     ></i>
        // </span>
        // </div>
        // }
        // if (header.field === "cellPhoneNumber") {
        //   const isPhoneNumberExist = data["cellPhoneNumber"]
        //   rowData[header.name] =
        //   <div style={{display: 'inline-block'}}>
        //       <span onClick={() => {
        //         if(isPhoneNumberExist){
        //           showCallModal(data)
        //         } else {
        //           setShowInvalidStatus(prev => ({...prev,["cellPhoneNumber"]:true}))
        //         }
        //       }} className='connection'>
        //       <i
        //         class="fe fe-phone-call"
        //         style={{
        //           color: "#fff",
        //           fontWeight: '500',
        //           fontSize: '16px'
        //         }}
        //       ></i>
        //     </span>
        //     </div>
        // }
        // if (header.name === "SMS") {
        //   rowData[header.name] =
        //     displayname.length > 1 ? (
        //       <span><i className="fa fa-comment" onClick={() => showSmsModal(data)} style={{cursor: 'pointer'}}></i></span>
        //     ) : (
        //       ""
        //     );
        // }
        if (header.field === "isMentor") {
          const isMentor = data?.isMentor
          rowData[header.name] = displayname.length > 1 ? (
            <span style={{display:"flex", height:"100%",alignItems:"center"}}><Mentor fillColor={isMentor ? "green": "white"} /></span>
          ) : null
        }
        if (header.field === 'isFavorite') {
          rowData[header.name] = displayname.length > 1 ? <span>{createStarforFavorite(data[header.field])}</span> : ''
        }

        if (header.field === "shift") {
          const shiftType = data["shiftType"];
          const tiltedColor = data?.tiltedBinocularColor;
          if (shiftType === 2) {
            rowData[header.name] = <span
              onClick={() => navigateDailyEncounterInfo(data)}
              style={{ cursor: 'pointer' }}
            ><i class="fa fa-hourglass" aria-hidden="true"></i></span>
          }
          else if (shiftType === 3) {
            rowData[header.name] = <span onClick={() => navigateMultiShift(
              data["jobUniqueId"],
              data["isClaimed"],
              data["acceptableTravelDistance"],
              data["candidateUniqueId"],
              data["jobShiftUniqueId"]
            )}
              style={{ cursor: 'pointer' }}
            ><i className='fa fa-binoculars ext-dark icon-align' /> {data["groupno"]}</span>
          }
          else if (+shiftType === shiftTypeObj.repost) {
            rowData[header.name] = <span><i className={`fa fa-binoculars text-dark icon-align fa-rotate-270 ${tiltedColor === tiltedColorCode.red ? 'tilted-red' : ''}`} /> {data["groupno"]}</span>
          }
        }
        if (header.field === "isClaimed") {
          let iconClass = '';
          const claimColor = data["anchorColor"];
          const isPosted = data["isPosted"]
          iconClass = claimColor === 1 ? "red-icon" : claimColor === 2 ? "yellow-icon" : claimColor === 3 ? "green-icon" : '';
          rowData[header.name] =
            <div data-toggle="tooltip" data-placement="top"
              title={`${claimColor === 2 ? 'Unclaimed' : claimColor === 3 ? 'Claimed' : (claimColor === 1 && isPosted === true) ? "Posted" : "Not Posted"}`}>
              <i className={`icon-align fa fa-anchor ${iconClass}`} />
              <span className="bold-text ms-1" style={{color: '#337166'}}>{data?.isConfirmedShift ? 'C' : ''}</span>
            </div>

        }
        if (header.field === "breakTimeFlash") {
          const statusColorMap = {
            1: 'green-icon',
            2: 'green-icon',
            0: 'grey-icon',
          };
          const icon_color = statusColorMap[data?.breakTimeFlash] ;
          rowData[header.name] = (
            <div
              data-toggle="tooltip"
              data-placement="top"
              title={data?.brekTypes ? data?.brekTypes : ''}
              style={{ display: data?.breakTimeCountTime && 'grid' }}
            >
              <i className={`fa icon-align fa-pause-circle-o ${icon_color} ${data?.breakTimeFlash === 2 ? 'blink_me' : ''}`} />
              {data?.breakTimeCountTime ? <span style={{ marginTop: '-0.75rem' }}>{data?.breakTimeCountTime}</span> : ''}
            </div>
          )
        }
      } else {
        // if (header.field === 'isClaimed') {
        //   const isClaimedtrure = data['isClaimed']
        //   const isUnClaimedtrure = data['isUnClaimed']
        //   const isCheckedOutTrue = data["isCheckedOut"]
        //   const showIcon = true;//gpsStatus !== 0 && gpsStatus !== 3;
        //   const iconClass = isClaimedtrure || (!isUnClaimedtrure && isCheckedOutTrue) === true ? 'green-icon' : isUnClaimedtrure === true ? 'yellow-icon' : 'red-icon'
        //   if (showIcon) {
        //     rowData[header.name] = {
        //       type: 'icon',
        //       class: `icon-align fa fa-anchor ${iconClass}`
        //     }
        //   }

        // }
        if (header.field === 'isUnClaimed') {
          const showIcon = true;
          const iconClassforclaimed = 'orange-icon'
          const isClaimedchk = data['isClaimed']
          const isCheckedInchk = data['isCheckedIn']
          const isCheckedOut = data["isCheckedOut"];
          const shiftType = data["shiftType"];
          // if (isClaimedchk === true) {
          //   if (parseInt(shiftType) === 3) {
          //     if (isCheckedInchk === false || (isCheckedInchk === true && isCheckedOut === true)) {
          //       rowData[header.name] = [
          //         {
          //           type: "icon",
          //           class: `icon-align fa fa-remove  ${iconClassforclaimed}`,
          //           onClick: () => {
          //             multiShiftUnClaimedDetail(data["jobShiftUniqueId"])
          //           },
          //         },
          //       ];
          //     }

          //   }
          //   else {
          //     if (isCheckedInchk === false) {
          //       rowData[header.name] = [
          //         {
          //           type: "icon",
          //           class: `icon-align fa fa-remove ${iconClassforclaimed}`,
          //           onClick: () => {
          //             showUnclaimdata(data["jobShiftUniqueId"]);
          //           },
          //         },
          //       ];
          //     }
          //   }

          // } 
          if (data['showUnclaimIcon'] === true) {
            if (parseInt(shiftType) === 3) {
              rowData[header.name] = [
                {
                  type: "icon",
                  class: `icon-align fa fa-remove  ${iconClassforclaimed}`,
                  onClick: () => {
                    multiShiftUnClaimedDetail(data["jobShiftUniqueId"])
                  },
                },
              ];
            }
            else {
              rowData[header.name] = [
                {
                  type: "icon",
                  class: `icon-align fa fa-remove ${iconClassforclaimed}`,
                  onClick: () => {
                    showUnclaimdata(data["jobShiftUniqueId"]);
                  },
                },
              ];
            }
          }
          // else if (parseInt(shiftType) === 4) {
          //   if (isClaimedchk === false && data['occurrenceJobStatus'] === 1) {
          //     rowData[header.name] = (<BiMessageEdit onClick={() => viewJobinSamePage(data["jobUniqueId"],
          //       data["currentMultiShiftJobDate"],
          //       data["jobsClaimId"],
          //       data["shiftStartTime"],
          //       data["shiftEndTime"],
          //       data["jobShiftUniqueId"],
          //       true)} size={'1.5rem'} color={'#20851a'} style={{ cursor: 'pointer' }} />)
          //   }
          //   // rowData[header.name] = (<BiMessageEdit  size={'1.5rem'} color={'#20851a'} />)
          // }
          else if (parseInt(shiftType) === 1 || parseInt(shiftType) === 4) {
            if (data["isUnClaimed"] === true && !data['candidateUniqueId']) {
              rowData[header.name] = (<BiMessageEdit onClick={() => viewJobinSamePage(data["jobUniqueId"],
                data["currentMultiShiftJobDate"],
                data["jobsClaimId"],
                data["shiftStartTime"],
                data["shiftEndTime"],
                data["jobShiftUniqueId"],
                true)} size={'1.5rem'} color={'#20851a'} style={{ cursor: 'pointer' }} />)
            }
          }
          else if (parseInt(shiftType) === 3) {
            // shiftType===4
            if (data["isUnClaimed"] === true && !data['candidateUniqueId']) {
              rowData[header.name] = (<BiMessageEdit onClick={() => editJob(
                data["jobUniqueId"],
                data["isClaimed"],
                data["acceptableTravelDistance"]
              )} size={'1.5rem'} color={'#20851a'} style={{ cursor: 'pointer' }} />)
            }
            // rowData[header.name] = (<BiMessageEdit  size={'1.5rem'} color={'#20851a'} />)
          }
        }
        if (header.field === 'isCheckedIn') {
          const isCheckedIn = data[header.field];
          const iconClass = isCheckedIn ? 'fa-sign-in green-icon' : 'fa-sign-in red-icon'
          rowData[header.name] = {
            type: 'icon',
            class: `fa icon-align ${iconClass}`
          }
        }
        if (header.field === 'isCheckedOut') {
          const isCheckedOut = data[header.field];
          const iconClass = isCheckedOut ? 'fa icon-align fa-sign-out fa-flip-horizontal green-icon' : 'fa icon-align fa-sign-out fa-flip-horizontal red-icon'
          rowData[header.name] = {
            type: 'icon',
            class: `fa icon-align ${iconClass}`
          }
        }

        if (header.field === 'isPaid') {
          const isPaid = data[header.field];
          const iconClass = isPaid ? 'green-icon fa-check-circle' : 'fa-times-circle red-icon'
          rowData[header.name] = {
            type: 'icon',
            class: `fa icon-align ${iconClass}`
          }
        }
        if (header.field === 'edit') {
          rowData[header.name] = {
            type: 'icon',
            class: `fa fa-pencil icon-align`,
            onClick: () => {
              editJob(data['jobUniqueId'], data['isClaimed'], data['acceptableTravelDistance'])
            }
          }
        }
        if (header.field === 'matching') {

          rowData[header.name] = {
            type: 'icon',
            class: `icon-align fa fa-link green-color-icon`,
            onClick: () => {

              matchingCandidate(data['jobUniqueId'], data['isClaimed'], data['acceptableTravelDistance'], data["jobsClaimId"], data['isShowMultishift'],
                data["jobShiftUniqueId"],data["shiftType"])

            }

          }

        }
        rowData['shiftType'] = data["shiftType"];
        // if (header.field === 'message') {
        //     rowData[header.name] = {
        //         type: 'icon',
        //         class: `icon-align fa fa-commenting`,
        //         onClick: () => {
        //             viewJobMessages(data['jobUniqueId'])
        //         }

        //     }
        // }

        if (header.field === 'view') {
          rowData[header.name] = {
            type: 'icon',
            class: `icon-align fa fa-file`,
            onClick: () => {
              viewJob(data['jobUniqueId'], data['acceptableTravelDistance'], data["currentMultiShiftJobDate"], data["jobsClaimId"], data["jobShiftUniqueId"])
            }
          }
        }

        if (header.field === 'delete') {
          rowData[header.name] = {
            type: 'icon',
            class: `icon-align fe fe-trash-2 fa-lg`,
            onClick: () => {
              showDeletedata(data['jobUniqueId'])
            }
          }
        }
        if (header.field === 'ratings') {
          rowData[header.name] = {
            type: 'ratings',
            value: data[header.field]
          }
        }
        if (header.name === 'Approval') {
          if (data?.jobApproversList?.length > 0) {
            rowData[header.name] = data[header.field]?.map(fld => {
              const isSuccess = fld.isApproved;
              const iconClass = isSuccess ? 'green-icon fa-check-circle' : 'fa-times-circle red-icon'
              return {
                type: 'icon',
                class: `fa icon-align ${iconClass}`
              }
            });
          } else {
            const iconClass = 'fa-times-circle red-icon';
            const approverCount = data?.approverCount;
            rowData[header.name] = Array.from({ length: approverCount }, (_, index) => ({
              type: "icon",
              class: `fa icon-align ${iconClass}`,
            }));
          }
        }
        if (header.name === 'Action') {
          const shiftType = data["shiftType"];
          let flag = true;
          if (shiftType === 4) {
            flag = false;
          }
          const actionArray = [
          //   {
          //   type: 'icon',
          //   class: `icon-align fa fa-commenting green-color-icon`,
          //   onClick: () => {
          //     viewJobMessages(data['jobShiftUniqueId'], data['isClaimed'], data['candidateUniqueId'])
          //   }
          // }, 
          {
            type: 'icon',
            class: `icon-align fa fa-file green-color-icon`,
            onClick: () => {
              viewJobinSamePage(
                data["jobUniqueId"],
                data["currentMultiShiftJobDate"],
                data["jobsClaimId"],
                data["shiftStartTime"],
                data["shiftEndTime"],
                data["jobShiftUniqueId"],
                false,
                data['shiftType']
              )
            }
          }, {
            type: 'icon',
            class: `fa fa-pencil icon-align green-color-icon`,
            onClick: () => {
              editJob(data['jobUniqueId'], data['isClaimed'], data['acceptableTravelDistance'])
            }
          }, {
            type: 'icon',
            class: `icon-align fe fe-trash-2 fa-lg green-color-icon`,
            onClick: () => {
              if (shiftType === 3 && data?.mainshiftClaimed === true) {
                toast.warning(
                  "This shift already claimed, Please unclaim before delete the shift"
                );
              }
              else if (data?.isClaimed === true) {
                toast.warning("This shift already claimed, Please unclaim before delete the shift")
              } else if (data?.isCheckedIn === true && data?.isCheckedOut !== true) {
                toast.warning("Shift is in progress, cannot be deleted now")
              } else {
                if (shiftType === 3) {
                  multiShiftClaimedDetail(data["jobShiftUniqueId"])
                } else {
                  showDeletedata(data["jobShiftUniqueId"]);
                }
              }
            }
          }];
          const actionArray2 = [
            // {
            //   type: "icon",
            //   class: `icon-align fa fa-commenting green-color-icon`,

            //   onClick: () => {
            //     viewJobMessages(
            //       data["jobShiftUniqueId"],
            //       data["isClaimed"],
            //       data["candidateUniqueId"]
            //     );
            //   },
            // },
            {
              type: "icon",
              class: `icon-align fa fa-file green-color-icon`,
              onClick: () => {
                viewJobinSamePage(
                  data["jobUniqueId"],
                  data["currentMultiShiftJobDate"],
                  data["jobsClaimId"],
                  data["shiftStartTime"],
                  data["shiftEndTime"],
                  data["jobShiftUniqueId"],
                  false,
                  data['shiftType']
                )
              },
            }
          ];
          rowData[header.name] = flag ? actionArray : actionArray2
        }
        if (header.field === 'gpsTrackingStatus') {
          const gpsStatus = data['gpsCurrentTrackingStatus'];

          const showIcon = true;//gpsStatus !== 0 && gpsStatus !== 3;
          //const iconClass = (gpsStatus === 1 || gpsStatus === 0 || gpsStatus === 3) ? 'green-icon' : gpsStatus === 2 ? 'yellow-icon' : 'red-icon'
          const iconClass = gpsStatus === 0 ? 'grey-icon' : (gpsStatus === 1 || gpsStatus === 3) ? 'green-icon' : gpsStatus === 2 ? 'yellow-icon' : 'red-icon'

          if (showIcon) {
            rowData[header.name] = {
              type: 'icon',
              class: `icon-align fa fa-map-marker ${iconClass}`,
              onClick: () => {
                showHideGps(data);
              }
            }
          }
        }

        if (header.name === "Bank") {
          const bankStatus = data["bankDetailsFlag"];
          const showIcon = true;
          const iconClass = data.anchorColor === 1 || data.anchorColor === 2 ? ("grey-icon") : data?.bankDetailsFlag === false ? ("red-icon") : ("green-icon")
          if (showIcon) {
            rowData[header.name] = {
              type: "icon",
              class: `icon-align fa fa-bank ${iconClass}`,
            };
          }
        }

        if (header.name === "Payrate") {
          const dollorStatus = data["candidatePayRateList"];
          const showIcon = true;
          // Popover Message
          const propover = (
            <Popover id="popover-basic">
              <Popover.Body>
                <table className='table'>
                  <thead>
                    <tr>
                      <th className="text-capitalize">Location</th>
                      <th className="text-capitalize text-center">Candidate hourly <br /> base rate</th>
                      <th className="text-capitalize text-center">Employer billing <br /> markup</th>
                      <th className="text-capitalize text-center">Employer hourly <br /> base rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dollorStatus?.map((item) => (
                      <tr className="border-bottom mt-2 bg-white">
                        <td className="text-center">{item?.locationName}</td>
                        <td className="text-center">{item?.hasRatePerHour}</td>
                        <td className="text-center">{item?.markup}</td>
                        <td className="text-center">{(parseFloat(item?.hasRatePerHour) * parseFloat(item?.markup)).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Popover.Body>
            </Popover>
          )
          const EncounterPropover = (
            <Popover id="popover-basic">
              <Popover.Body>
                <table className='table'>
                  <thead>
                    <tr>
                      <th className="text-capitalize">Location</th>
                      <th className="text-capitalize">Appointment type</th>
                      <th className="text-capitalize text-center">Candidate hourly <br /> base rate</th>
                      <th className="text-capitalize text-center">Employer hourly <br /> base rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    {dollorStatus?.map((item) => (
                      <tr className="border-bottom mt-2 bg-white">
                        <td className="text-center">{item?.locationName}</td>
                        <td className="text-center">{item?.appointmentTypes}</td>
                        <td className="text-center">{item?.hasRatePerHour}</td>
                        <td className="text-center">{item?.employerHasRatePerHour}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Popover.Body>
            </Popover>
          )


          // Added a Icon and Overlay Condition
          if (showIcon) {
            rowData[header.name] = (
              <>
                <span variant="success">
                  {data.anchorColor === 1 || data.anchorColor === 2 ? (<i className="mx-1 fa fa-money grey-icon" />) : data?.payRateSetupFlag === false ? (<i onClick={() => getDollarDetails(data)} className="mx-1 fa fa-money red-icon" />) : (<i onClick={() => getDollarDetails(data)} className="mx-1 fa fa-money green-icon" />)}
                </span>
              </>
            );
          }
        }
        // if (header.name === "Dollar") {
        //   const dollorStatus = data["candidatePayRateList"];
        //   const showIcon = true;
        //   // Popover Message
        //   const propover = (
        //     <Popover id="popover-basic">
        //       <Popover.Body>
        //         <table className='table'>
        //           <thead>
        //             <tr>
        //               <th className="text-capitalize">Location</th>
        //               <th className="text-capitalize text-center">Candidate hourly <br /> base rate</th>
        //               <th className="text-capitalize text-center">Employer billing <br /> markup</th>
        //               <th className="text-capitalize text-center">Employer hourly <br /> base rate</th>
        //             </tr>
        //           </thead>
        //           <tbody>
        //             {dollorStatus?.map((item) => (
        //               <tr className="border-bottom mt-2 bg-white">
        //                 <td className="text-center">{item?.locationName}</td>
        //                 <td className="text-center">{item?.hasRatePerHour}</td>
        //                 <td className="text-center">{item?.markup}</td>
        //                 <td className="text-center">{(parseFloat(item?.hasRatePerHour) * parseFloat(item?.markup)).toFixed(2)}</td>
        //               </tr>
        //             ))}
        //           </tbody>
        //         </table>
        //       </Popover.Body>
        //     </Popover>
        //   )
        //   const EncounterPropover = (
        //     <Popover id="popover-basic">
        //       <Popover.Body>
        //         <table className='table'>
        //           <thead>
        //             <tr>
        //               <th className="text-capitalize">Location</th>
        //               <th className="text-capitalize">Appointment type</th>
        //               <th className="text-capitalize text-center">Candidate hourly <br /> base rate</th>
        //               <th className="text-capitalize text-center">Employer hourly <br /> base rate</th>
        //             </tr>
        //           </thead>
        //           <tbody>
        //             {dollorStatus?.map((item) => (
        //               <tr className="border-bottom mt-2 bg-white">
        //                 <td className="text-center">{item?.locationName}</td>
        //                 <td className="text-center">{item?.appointmentTypes}</td>
        //                 <td className="text-center">{item?.hasRatePerHour}</td>
        //                 <td className="text-center">{item?.employerHasRatePerHour}</td>
        //               </tr>
        //             ))}
        //           </tbody>
        //         </table>
        //       </Popover.Body>
        //     </Popover>
        //   )


        //   // Added a Icon and Overlay Condition
        //   if (showIcon) {
        //     rowData[header.name] = (
        //       <>
        //         <OverlayTrigger placement="left" delay={{ show: 250, hide: 400 }} overlay={data.anchorColor === 1 || data.anchorColor === 2 || data?.payRateSetupFlag === false ? <span></span> : (data?.shiftType === 2 ? EncounterPropover : propover)}>
        //           <span variant="success">
        //             {data.anchorColor === 1 || data.anchorColor === 2 ? (<i className="mx-1 fa fa-money grey-icon" />) : data?.payRateSetupFlag === false ? (<i className="mx-1 fa fa-money red-icon" />) : (<i className="mx-1 fa fa-money green-icon" />)}
        //           </span>
        //         </OverlayTrigger>
        //       </>
        //     );
        //   }
        // }
        // if (header.name === "Departments") {
        //   const showIcon = true;
        //   if (showIcon) {
        //       rowData[header.name] =    
        //       <div
        //       ref={departmentRef}
        //       class="fa fa-building "
        //       onClick={(e,) => clickJobDepartmentHandler(e,data)}
        //       style={{
        //         fontSize: "1.15rem",
        //         position: "relative",
        //         marginLeft:"6px"
        //       }}
        //     >
        //     </div>

        //   }
        // }

      }
    });
    return rowData;
  }
  const formatTableData = (data) => {
    const tableData = {
      headers,
      rows: data?.jobShifts?.map(data => ({
        columns: generateRowData(data, headers)
      })),
      options: {
        sortable: false,
        filter: false,
        layout: 'autoHeight',
        pagination: true,
        pageSize: pageSize || 10,
        height: '100%',
        resizable: true,
        showToggle: true,
        refreshFlag: true,
        gridloader,
        loader: true
      },
      pageData: createPageData(page, pageSize, data?.totalCount),
      totalCount: data?.totalCount,
      currentPage: page,
      pageSize,
      firstPage: gotoFirstPage,
      nextPage: gotoNextPage,
      previousPage: gotoPreviousPage,
      lastPage: gotoLastPage,
      updatePageSize: updatePageSize,
      gotoPage: gotoSelectedPage,
      headerComponentParams: {
        sort: (order, column) => {
             //upArrow is clicked , make as down arrow and vice versa and default uparrow => Asc
             const sortType = getSortOrder(order);
          dispatch(updateSort(sortType, column)).then(() => {
            dispatch(loadShiftsCoverageListings({ url, empId }));
          });
        },
        headers
      }
    }
    return tableData;
  }

  const viewJob = (jobId, acceptableTravelDistance, jobDate, jobsClaimId, jobShiftUniqueId) => {
    dispatch(updateJobId(jobId, "/shiftscoverage")).then(() => {
      navigate("/jobsummary", {
        state: {
          jobUniqueId: jobId,
          gotoMatching: true,
          save: false,
          acceptableTravelDistance: acceptableTravelDistance,
          jobDate,
          jobsClaimId,
          jobShiftUniqueId,
          PageName: "allShifts",
          viewJobTitle: "Shift Awaiting Approval"
        }
      });
    });
  }

  const viewJobMessages = (jobId, isClaimed, candidateId) => {
    // if (!isClaimed) {
    //     setShowMessageModal (!showMessageModal)
    // } else {
    navigate("/jobmessages", {
      state: {
        jobUniqueId: jobId,
        candidateUniqueId: candidateId,
      }
    });
    // }
  }

  // const editJob = (jobId) => {
  //     dispatch(resetJobOpportunityInfo()).then(() => {
  //         dispatch(setJobId(jobId)).then(() => {
  //             navigate("/jobopportunity");
  //         });
  //     })
  // }

  const matchingCandidate = (jobId, isClaimed, acceptableTravelDistance, jobsClaimId, multishiftFlag, jobShiftUniqueId,hideEditJobShiftType) => {

    if (isClaimed) {
      setShowModal(!showModal)
    } else {
      navigate("/matchingcandidate", {

        state: {
          matchingJobid: jobShiftUniqueId,
          acceptableTravelDistance: acceptableTravelDistance,
          jobsClaimId: jobsClaimId,
          multishiftFlag: multishiftFlag,
          jobUniqueId: jobId,
          NoOfShiftsneeded: false,
          previousPath: '/shiftscoverage',
          hideEditJobShiftType:hideEditJobShiftType
        }

      });
    }

  }

  const editJob = (jobId, isClaimed, acceptableTravelDistance) => {

    if (isClaimed) {
      setShowJobMessageModal(!showJobMessageModal)
    } else {
      dispatch(resetJobOpportunityInfo()).then(() => {
        dispatch(editPost()).then(() => {
          dispatch(setJobId(jobId)).then(() => {
            navigate("/jobopportunity", {
              state: {
                acceptableTravelDistance: acceptableTravelDistance
              }
            });
          });
        })
      })
    }
  }

  const cancelJobView = () => {
    dispatch(updateJobId(undefined)).then(() => {
      navigate("/shiftscoverage");
    });
  }

  const showHideGps = (jobData) => {
    if (jobData && jobData.jobUniqueId) {
      setOpenGps({
        show: true,
        jobData: jobData
      })
    } else {
      setOpenGps({
        show: false,
        jobData: undefined
      });
    }
  }

  const handleClose = () => setShow(false);
  const handleClosefalse = () => {
    // Delete Reasons Reset data Input Value
    setDeleteModalFormData({
      reason: "",
      comments: "",
    });
    setDeleteErrorsModalFormData({
      reasonError: "",
      commentsError: "",
    });
    setdeletedata({
      show: false
    })
  }
  const handleCloseUnclaim = () => setShow(false);
  const handleClosefalseUnclaim = () => {
    setUnclaimData(false)
    setErrorsModalFormData({
      commentsError: '',
      reasonError: "",
    });
    setModalFormData({
      reason: "",
      comments: "",
    })
  }
  const handleDeleteData = () => {
    // Error Handling for single shift delete Reasons in Dropdown
    if (!DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(DeleteModalFormData.reason) === 0) {
        if (!DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            ...DeleteErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      "jobsShiftUniqueId": deleteId,
      "AppUserId": AppuseridValue,
      deleteReasonId: DeleteModalFormData.reason,
      otherDeleteReason: DeleteModalFormData.comments,
    }
    dispatch(deleteJob({ url: `${config.baseUrl}/Employers/delete-jobshifts-details`, params })).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    })
      .then(() => {
        setdeletedata({
          show: false
        })
        setDeleteModalFormData({
          reason: "",
          comments: "",
        });
      })
  }


  const unclaim = () => {
    singleUnclaimOccurrence(UnclaimId)
  }

  const singleUnclaimOccurrence = (jobsShiftUniqueId) => {
    // Confirmation Modal Box UnClaim Reasons Error Handling 
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }

    const params = {
      jobsShiftUniqueId,
      "unClaimReasonId": ModalFormData.reason,
      "otherUnClaimReason": ModalFormData.comments
    }

    dispatch(UnclaimMultiShiftJob(config.baseUrl, params)).then(() => {
      setUnclaimData(false)
      setUnclaimId("")
      setErrorsModalFormData({
        reasonError: "",
        commentsError: "",
      });
      setModalFormData({
        reason: "",
        comments: "",
      })
      dispatch(loadShiftsCoverageListings({ url, empId }));
    })
  }
  const UnclaimedbyEmployer = () => {
    // Confirmation Modal Box UnClaim Reasons Error Handling 
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }

    const params = {
      "JobUniqueId": UnclaimId,
      "unClaimReasonId": ModalFormData.reason,
      "otherUnClaimReason": ModalFormData.comments
    }

    dispatch(UnclaimedbyEmployerApi({ url: `${config.baseUrl}/Candidates/UnClaimByEmployer`, params })).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    }).then(() => {
      setUnclaimData({
        show: false
      })
      setErrorsModalFormData({
        commentsError: '',
        reasonError: "",
      });
      setModalFormData({
        reason: "",
        comments: "",
      })
    })
  }

  const UnclaimedbyEmployerForChild = () => {
    // Confirmation Modal Box Error Handling Dropdown Validation
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }

    const params = {
      ...unclaimForChild,
      "unClaimReasonId": ModalFormData.reason,
      "otherUnClaimReason": ModalFormData.comments
    };

    dispatch(
      UnclaimedbyEmployerApi({
        url: `${config.baseUrl}/Candidates/unclaimoccurrancebyemployer`,
        params,
      })
    ).then(() => {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    }).then(() => {
      setUnclaimData({
        show: false,
      })
      setErrorsModalFormData({
        commentsError: '',
        reasonError: "",
      });
      setModalFormData({
        reason: "",
        comments: "",
      })
    })
  };

  const showDeletedata = (jobId) => {
    setDeleteId(jobId)

    if (jobId) {
      setdeletedata({
        show: true,
        jobId: jobId
      })
    } else {
      setdeletedata({
        show: false,
        jobId: undefined
      });
    }
  }
  const hideModal = () => {
    setShowModal(!showModal)
  }
  const showUnclaimdata = (unClaimedId) => {
    if (unClaimedId) {
      setUnclaimData(true)
      setUnclaimId(unClaimedId)
    }
  }


  const hideMessageModal = () => {
    setShowMessageModal(!showMessageModal)
  }

  const hideJobMessageModal = () => {
    setShowJobMessageModal(!showJobMessageModal)
  }

  const multiShiftClaimedDetail = (jobUniqueId) => {
    setmulJobUniqueId(jobUniqueId)
    const params = {
      "jobsShiftUniqueId": jobUniqueId,
      "appUserId": 0
    }
    dispatch(getMultiShiftDetail(config.baseUrl, params)).then(() => dispatch(multishiftFlag(true)))
  }

  const setmultishiftFlag = () => {
    dispatch(multishiftFlag(false))
  }

  const deleteMultishift = () => {
    // Error Handling for single shift delete Reasons in Dropdown
    if (!DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (DeleteModalFormData.reason) {
      setDeleteErrorsModalFormData({
        ...DeleteErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(DeleteModalFormData.reason) === 0) {
        if (!DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            ...DeleteErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (DeleteModalFormData.comments) {
          setDeleteErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }
    const params = {
      "jobsShiftUniqueId": mulJobUniqueId,
      "appUserId": 0,
      deleteReasonId: DeleteModalFormData.reason,
      otherDeleteReason: DeleteModalFormData.comments,
    }
    dispatch(DeleteMultiShiftJob(config.baseUrl, params)).then(() => {
      setmulJobUniqueId('')
      dispatch(loadShiftsCoverageListings({ url, empId }));
    })
      .then(() => {
        setDeleteModalFormData({
          reason: "",
          comments: "",
        });
        setmultishiftFlag();
      })
  }

  const closeViewJob = () => {
    setShowViewJob(!showViewJob);
    if (updatedShiftTime) {
      dispatch(loadShiftsCoverageListings({ url, empId }));
    }
    dispatch(resetModifyOccurrence())
    dispatch(refreshMultishiftInfo(false))

  };
  const multiShiftUnClaimedDetail = (jobUniqueId) => {
    setmulJobUniqueId(jobUniqueId)
    const params = {
      "jobsShiftUniqueId": jobUniqueId,
      "appUserId": 0
    }
    dispatch(getMultiShiftDetail(config.baseUrl, params)).then(() => dispatch(multishiftUnClaimByEmpFlag(true)))
  }

  const setmultishiftUnClaimByEmpFlag = () => {
    dispatch(multishiftUnClaimByEmpFlag(false))
    setErrorsModalFormData({
      commentsError: '',
      reasonError: "",
    });
    setModalFormData({
      reason: "",
      comments: "",
    })
  }

  const unClaimMultishift = () => {
    if (!ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "Please choose any Reason",
      });
      return;
    } else if (ModalFormData.reason) {
      setErrorsModalFormData({
        ...ErrorsModalFormData,
        reasonError: "",
      });
      if (parseInt(ModalFormData.reason) === 0) {
        if (!ModalFormData.comments) {
          setErrorsModalFormData({
            ...ErrorsModalFormData,
            commentsError: "Please Enter the comments",
          });
          return;
        } else if (ModalFormData.comments) {
          setErrorsModalFormData({
            reasonError: "",
            commentsError: "",
          });
        }
      }
    }

    const params = {
      "jobsShiftUniqueId": mulJobUniqueId,
      // "appUserId": 0,
      "unClaimReasonId": ModalFormData.reason,
      "otherUnClaimReason": ModalFormData.comments
    }

    dispatch(UnclaimMultiShiftJob(config.baseUrl, params)).then(() => {
      setmulJobUniqueId('')
      dispatch(loadShiftsCoverageListings({ url, empId }));
    }).then(() => {
      setErrorsModalFormData({
        commentsError: '',
        reasonError: "",
      });
      setModalFormData({
        reason: "",
        comments: "",
      })
      setmultishiftUnClaimByEmpFlag()
    })
  }

  return <div className="page main-margin">
    {/* <Loader /> */}
    {loadingFlag > 0 && <Spinner />}

    <Header />
    <Sidebar />
    <EmailModal
      showModal={emailModalInd}
      handleClose={showEmailModal}
      data={emailModalData}
      handleSave={saveEmailModal}
      handleForm={getEmailModalData}
      formData={emailModalGetData}
      listData={emailModalList}
      sendAllEmail={sendAllEmail}
      sendReadEmail={sendReadEmail}
    />
    <SMSModal
      showModal={smsModalInd}
      handleClose={showSmsModal}
      data={smsModalData}
      handleSave={saveSmsModal}
      formData={smsModalGetData}
      handleForm={getSmsModalData}
      listData={smsModalList}
      sendAllSms={sendAllSms}
      smsShiftCoveragePageFlag={smsShiftCoveragePageFlag}
      candidateName={candidateName}
    />
    <CallModal
      showModal={callModalInd}
      handleClose={showCallModal}
      listData={callModalList}
      phoneNumber={callParams.phoneNumber}
      candidateUniqueId={callParams.candidateUniqueId}
      getCallHistoryList={getCallHistoryList}
      jobsClaimId={callParams.jobsClaimId}
      jobsShiftUniqueId={callParams.jobsShiftUniqueId}
    />

    <div className="page-main">
      <div className="main-content app-content mt-0 main-background">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <h1 className="page-title">All Shifts</h1>
            </div>
            <div className="card">
              <div className="custom-overlay">
                {dollarOpen?.status && (
                  <Modal
                    showHide={() =>
                      setDollarOpen({
                        status: false,
                        jobShiftUniqueId: null,
                        result: [],
                      })
                    }
                    size={"lg"}
                    center={true}
                    onlyClose={true}
                  >
                    <PayRateTable dollarOpen={dollarOpen} />
                  </Modal>
                )}
                {showDepartmentList?.status &&
                  <Modal
                    showHide={() => setShowDepartmentList({ status: false, jobShiftId: null, result: [] })}
                    label={"Departments"}
                    size={"md"}
                    center={true}
                    onlyClose={true}
                  >
                    {showDepartmentList?.result?.map((deps, index) => (
                      <p key={index}>{deps?.departmentName}</p>
                    ))}
                  </Modal>
                  // <div
                  // id=""
                  // className="custom-popover" 
                  //   style={{
                  //     position: "fixed",
                  //   top: popupPosition.top, left: popupPosition.left,
                  //   zIndex:"999999999999999999",
                  //   background:"#fff"
                  //   }}
                  // >
                  //  {showDepartmentList?.result?.map(deps => (
                  //   <p key={deps?.id}>{deps?.name}</p>
                  //  ))}
                  // </div>
                }
              </div>
              {showViewJob && (
                <ModalGoTo
                  showHide={closeViewJob}
                  save={saveViewJob}
                // backPath={backPath}
                // label={"Job Summary"}
                // relativeToParent = {true}
                >
                  <ViewJob pageName="shiftscoverage" />
                </ModalGoTo>
              )}
              {showModal && <Modal showHide={hideModal} label={"Alert"} size={'md'} center={true} onlyClose={true}><span className="fw-bold">This shift is already claimed and cannot be posted again !</span></Modal>}
              {/* {showMessageModal && <Modal showHide={hideMessageModal} label={"Alert"} size={'md'} center={true} onlyClose={true}><span className="fw-bold">There are no Claimed Candidates for this Job !</span></Modal>} */}
              {showJobMessageModal && <Modal showHide={hideJobMessageModal} label={"Alert"} size={'md'} center={true} onlyClose={true}><span className="fw-bold">This shift is already claimed and cannot be edited !</span></Modal>}
              {
                openGps.show && <Modal label={"GPS"} onlyClose={true} showHide={showHideGps}>
                  <GPSInfo {...openGps.jobData} show={openGps.show} />
                </Modal>
              }
              {
                (showInvalidStatus?.SMS || showInvalidStatus?.cellPhoneNumber || showInvalidStatus?.email) &&
                <Modal
                  showHide={closeInvalidStatus}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={true}
                >
                  <span className="fw-bold">
                    {
                      showInvalidStatus.email ? "Invalid Email" : showInvalidStatus.cellPhoneNumber ? "Invalid Cell Phone Number" : showInvalidStatus?.SMS ? "Invalid SMS" : ""
                    }
                  </span>
                </Modal>
              }

              {
                multiShiftclaimDetailFlag && <Modal
                  showHide={setmultishiftFlag}
                  saveFunction={deleteMultishift}
                  label={"Alert"}
                  size={"md"}
                  center={true}
                  onlyClose={false}
                  buttonName={'Delete'}
                >
                  <ul>
                    <li className="py-1" >
                      <span>Total Occurrence Count :</span>
                      <span className="fw-bold"> {multiShiftclaimedDetail?.totalOccurrenceCount}</span>
                    </li>
                    <li className="py-1">
                      <span>Completed Occurrence Count :</span>
                      <span className="fw-bold"> {multiShiftclaimedDetail?.completedOccurrenceCount}</span>
                    </li>
                    <li className="py-1">
                      <span>UnClaimed Occurrence Count:</span>
                      <span className="fw-bold">{multiShiftclaimedDetail?.unClaimedOccurrenceCount}</span>
                    </li>
                  </ul>
                  <span className="fw-bold mt-4 d-inline-block">
                    Are you sure want to delete the multishift?
                  </span>
                  {/* Delete Reasons Dropdown */}
                  <div className="mt-5">
                    <label for="reason" className="mx-2">
                      Choose a Reason :
                    </label>
                    <select
                      name="reason"
                      id="reason"
                      className="form-select form-control"
                      required
                      onChange={DeleteConfirmationModalBoxHandleChange}
                    >
                      <option selected disabled>
                        Choose any one
                      </option>
                      {deleteEmployerReasons.map((reasonLists, index) => {
                        return (
                          <option key={index} value={reasonLists.id}>
                            {reasonLists.name}
                          </option>
                        );
                      })}
                    </select>
                    {
                      <span className="text-danger mx-2">
                        {DeleteErrorsModalFormData?.reasonError}
                      </span>
                    }
                    {parseInt(DeleteModalFormData.reason) === 0 ? (
                      <div className="mt-2">
                        <textarea
                          className="form-control"
                          name="comments"
                          value={DeleteModalFormData.comments}
                          onChange={DeleteConfirmationModalBoxHandleChange}
                        ></textarea>
                        {
                          <span className="text-danger mx-2">
                            {DeleteErrorsModalFormData?.commentsError}
                          </span>
                        }
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Modal>
              }
              {
                multiShiftUnClaimFlag && <Modal
                  showHide={setmultishiftUnClaimByEmpFlag}
                  saveFunction={unClaimMultishift}
                  label={"Choose the Unclaim Reason"}
                  size={"md"}
                  center={true}
                  onlyClose={false}
                  buttonName={'Unclaim'}
                  children={<div></div>} >
                  <ul>
                    <li className="py-1" >
                      <span>Total Occurrence Count :</span>
                      <span className="fw-bold"> {multiShiftclaimedDetail?.totalOccurrenceCount}</span>
                    </li>
                    <li className="py-1">
                      <span>Completed Occurrence Count :</span>
                      <span className="fw-bold"> {multiShiftclaimedDetail?.completedOccurrenceCount}</span>
                    </li>
                    <li className="py-1">
                      <span>UnClaimed Occurrence Count:</span>
                      <span className="fw-bold">{multiShiftclaimedDetail?.unClaimedOccurrenceCount}</span>
                    </li>
                  </ul>
                  <span className="fw-bold mt-4 d-inline-block">
                    Are you sure want to unclaim the multishift?
                  </span>
                  {/* UnClaim Reasons Dropdown */}
                  <div>
                    <label for="reason" className="mx-2">
                      Choose a Reason :
                    </label>
                    <select
                      name="reason"
                      id="reason"
                      className="form-select form-control"
                      required
                      onChange={ConfirmationModalBoxHandleChange}
                    >
                      <option selected disabled>
                        Choose any one
                      </option>
                      {unClaimEmployerReasons.map((reasonLists, index) => {
                        return (
                          <option key={index} value={reasonLists.id}>
                            {reasonLists.name}
                          </option>
                        );
                      })}
                    </select>
                    {
                      <span className="text-danger mx-2">
                        {ErrorsModalFormData?.reasonError}
                      </span>
                    }
                    {parseInt(ModalFormData.reason) === 0 ? (
                      <div className="mt-2">
                        <textarea
                          className="form-control"
                          name="comments"
                          value={ModalFormData.comments}
                          onChange={ConfirmationModalBoxHandleChange}
                        ></textarea>
                        {
                          <span className="text-danger mx-2">
                            {ErrorsModalFormData?.commentsError}
                          </span>
                        }
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Modal>
              }
              {deletedata.show &&
                <DeleteModal showDelete={true} handleDeleteClose={handleClosefalse} handleDelete={handleDeleteData}
                  children={
                    <div>
                      {/* Delete Reasons Dropdown */}
                      <div className="mt-5">
                        <label for="reason" className="mx-2">
                          Choose a Reason :
                        </label>
                        <select
                          name="reason"
                          id="reason"
                          className="form-select form-control"
                          required
                          onChange={DeleteConfirmationModalBoxHandleChange}
                        >
                          <option selected disabled>
                            Choose any one
                          </option>
                          {deleteEmployerReasons.map((reasonLists, index) => {
                            return (
                              <option key={index} value={reasonLists.id}>
                                {reasonLists.name}
                              </option>
                            );
                          })}
                        </select>
                        {
                          <span className="text-danger mx-2">
                            {DeleteErrorsModalFormData?.reasonError}
                          </span>
                        }
                        {parseInt(DeleteModalFormData.reason) === 0 ? (
                          <div className="mt-2">
                            <textarea
                              className="form-control"
                              name="comments"
                              value={DeleteModalFormData.comments}
                              onChange={
                                DeleteConfirmationModalBoxHandleChange
                              }
                            ></textarea>
                            {
                              <span className="text-danger mx-2">
                                {DeleteErrorsModalFormData?.commentsError}
                              </span>
                            }
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  }
                />
              }
              {Unclaimdata === true ?
                <Unclaimedmodalpopup showUnclaim={true} handleUnclaimClose={handleClosefalseUnclaim} handleUnclaim={unclaim}
                  children={<div>
                    {/* UnClaim Reasons Dropdown */}
                    <div className="mt-5">
                      <label for="reason" className="mx-2">
                        Choose a Reason :
                      </label>
                      <select
                        name="reason"
                        id="reason"
                        className="form-select form-control"
                        required
                        onChange={ConfirmationModalBoxHandleChange}
                      >
                        <option selected disabled>
                          Choose any one
                        </option>
                        {unClaimEmployerReasons.map((reasonLists, index) => {
                          return (
                            <option key={index} value={reasonLists.id}>
                              {reasonLists.name}
                            </option>
                          );
                        })}
                      </select>
                      {
                        <span className="text-danger mx-2">
                          {ErrorsModalFormData?.reasonError}
                        </span>
                      }
                      {parseInt(ModalFormData.reason) === 0 ? (
                        <div className="mt-2">
                          <textarea
                            className="form-control"
                            name="comments"
                            value={ModalFormData.comments}
                            onChange={ConfirmationModalBoxHandleChange}
                          ></textarea>
                          {
                            <span className="text-danger mx-2">
                              {ErrorsModalFormData?.commentsError}
                            </span>
                          }
                        </div>
                      ) : (
                        ""
                      )}
                    </div> </div>} /> : ""}
              <div className="card-body">
                <div className='col-lg-12 col-md-12'>
                  <ShiftCount pagename={'allshift'} ref={childRef} />
                </div>
                <div className="row">
                  <div className='col-lg-12 col-md-12'>
                    <ShiftsCoverageFilter />
                  </div>
                </div>
                <div className="row">
                  <div className='col-lg-12 col-md-12 openshift'>
                    <DataGrid {...formatTableData(data)} refresh={refresh} pageName={'allShift'} />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
                            <div className="col-xl-12 col-md-12 col-lg-12">
                                <div className="card">
                                    <div className="card-body">
                                        <DataGrid {...formatTableData(data)} />
                                    </div>
                                </div>
                            </div>
                        </div> */}
          </div>
        </div>
      </div>
    </div>
  </div>
}
